import React from "react";
import PropTypes from "prop-types";
import styles from "../../styles.module.scss";
import { I18n } from "@td/shared_utils";
import { Formik, Field, Form } from "formik";

const PracticeTeamSearchForm = ({ setSearchParams, isFetching }) => {
  return (
    <Formik
      initialValues={{
        id: "",
        name: "",
      }}
      onSubmit={(values) => {
        setSearchParams(values);
      }}
    >
      <Form>
        <table className={`fields ${styles.practiceTeamSearch}`}>
          <tbody>
            <tr>
              <th>
                <label
                  htmlFor="name"
                  data-testid="practice-team-name-label"
                >
                  <I18n scope="practice_team.fields" text="name" />
                </label>
              </th>
              <td>
                <Field
                  id="name"
                  name="name"
                  type="text"
                  data-testid="practice-team-name-input"
                />
              </td>
            </tr>
            <tr>
              <th>
                <label
                  htmlFor="id"
                  data-testid="practice-team-id-label"
                >
                  <I18n scope="practice_team.fields" text="id" />
                </label>
              </th>
              <td>
                <Field
                  id="id"
                  name="id"
                  type="text"
                  data-testid="practice-team-id-input"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <button
          type="submit"
          className="button"
          disabled={isFetching}
          data-testid="practice-team-search-button"
        >
          <I18n scope="practice_team.actions" text={isFetching ? "searching" : "search"} />
        </button>
      </Form>
    </Formik>
  );
};

PracticeTeamSearchForm.propTypes = {
  setSearchParams: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

export default PracticeTeamSearchForm;
